import { api } from 'shared';
import { z } from 'zod';

type CreateOrderDtoItem = {
    name: string,
    count: number,
    price?: number,
    url: string,
}

type CreateOrderDto = {
    name: string,
    phone: string,
    email: string,
    date: number,
    address: string,
    comment?: string,
    items: CreateOrderDtoItem[]
}

export const CreateOrderResponseSchema = z.object({
    data: z.object({
        id: z.number(),
    }),
});

export const createOrder = async (
    {
        name,
        phone,
        email,
        date,
        address,
        comment,
        items,
    }: CreateOrderDto,
) => (
    api.post<z.infer<typeof CreateOrderResponseSchema>>(
        '/orders',
        {
            data: {
                name,
                phone,
                email,
                date,
                address,
                comment,
                items,
            },
        },
        {},
        CreateOrderResponseSchema,
    )
);
